<template>
  <Badge
    :size="size"
    :shift="shift"
    :direction="direction"
    tooltipText="Profile Not Verified"
    tooltipIcon="sr-2 sr-v2-question-mark-circle text-red-300"
  >
    <BadgeNotVerified
      class="cursor-pointer"
      :style="{ height: sizeInPixels + 'px' }"
    />
  </Badge>
</template>

<script>
import Badge from "./Badge";
import TooltipContent from "./TooltipContent";
import HelpModal from "./HelpModal";
import BadgeNotVerified from "@/srui/svg/BadgeNotVerified";

export default {
  components: { Badge, BadgeNotVerified },
  props: ["size", "shift", "direction"],
  computed: {
    sizeInPixels() {
      return {
        sm: 10,
        base: 12,
        lg: 14,
        xl: 16,
        "2xl": 20,
        "4xl": 48,
      }[this.size];
    },
  },
};
</script>